import {logger, BrowserReporter, type Extension, type Reporter} from '@tinkoff/logger';
import {DateTime} from 'luxon';

import {sentryReporter} from 'utils/sentry';

const desktopReporter: Reporter = {
    log: (logObj) => {
        if (logObj.type !== 'error') {
            return;
        }

        window.internalAPI?.sendError?.(logObj);
    },
};

// eslint-disable-next-line no-process-env
const IS_DEV = process.env.NODE_ENV === 'development';

const reporters = [sentryReporter, desktopReporter];
const extensions: Extension[] = [];

if (IS_DEV) {
    reporters.push(new BrowserReporter());
    extensions.push({
        extend(logObj) {
            const name = logObj.name;

            return {
                ...logObj,
                name: `${DateTime.now().toFormat('HH:mm:ss.SSS')} - ${name}`,
            };
        },
    });
}

export const TimeLogger = logger({
    enabled: true,
    name: 'Time',
    reporters,
    extensions,
});
